import { MeterOptions } from '../types';

export const combineByValue = (meterOptions: MeterOptions[]) =>
  meterOptions.reduce(
    (previousVersion, current) => {
      const currentVersion = { name: 'Other', value: current.value + previousVersion.value };
      return { ...previousVersion, ...currentVersion };
    },
    { name: '', value: 0 },
  );
